import styled, { css } from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const Input = styled.input`
  background-color: #eeeeee;
  font-size: ${({ fontSize }) => fontSize || ""} !important;
  width: 100%;
  height: 100% !important;
  padding: 10px;
  flex: 1;
  opacity: ${props => (props.isActive || props.isActive === undefined ? "1" : "0.5")};

  &:placeholder-shown {
    font-style: unset;
    font-size: 12px;
  }

  ${({ isLoading }) =>
    isLoading &&
    `
    background-color: rgba(0, 0, 0, 0.15) !important;
    color: rgba(0, 0, 0, 0) !important;
    cursor: default !important;
  `}
`

export const Title = styled.div`
  color: #787878;
  font-size: ${props => props.fontSizeTitle};
  color: ${props => props.colorTitle};
  font-weight: 600;
  height: ${props => props.heightTitle};
  display: flex;
  align-items: center;
  text-transform: uppercase;
  ${({ isLoading }) =>
    isLoading &&
    `
    p {
      background-color: rgba(0, 0, 0, 0.15) !important;
      color: rgba(0, 0, 0, 0) !important;
      border: 1px solid rgba(0, 0, 0, 0.15) !important;
      cursor: default !important;
      border-radius: 5px;
    }
  `}
`

export const InputContainer = styled.div.attrs(props => ({
  style: {
    ...props.style,
    border: props => (props.unvalidValue ? "1px solid red" : "none"),
  },
}))`
  height: 40px;
  display: flex;
  flex-direction: row;
  color: #707070;
  font-size: 14px;
  border-radius: 5px;
  /* background-color: #eeeeee; */
  transition: 0.3s;

  ${({ isHiddenFleche }) =>
    isHiddenFleche &&
    `
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type="number"] {
        -moz-appearance: textfield;
    }
  `}

  ${({ withMinWidth }) =>
    withMinWidth &&
    css`
      min-width: 250px;
    `}
`

export const SearchIconContainer = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: ${({ enableClick }) => (enableClick ? "pointer" : "")};
`

export const ErrorMessage = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
  font-style: italic;
  color: red;
`

export const ActiveIconContainer = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #fff;

  &:hover {
    .active {
      background-color: ${({ primaryActionColor }) =>
        primaryActionColor ? primaryActionColor : ""};
      border: none;
    }
  }
`

export const ActiveItem = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  border: ${({ active }) => (active ? "" : "2px solid #787878")};
  background-color: ${({ primaryActionColor, active }) => (active ? primaryActionColor : "")};
  color: #fff;

  i {
    font-size: 0.7rem;
  }
`
